var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPtSessionAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 111,
    viewBox: "0 0 117 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F6F6F6",
    stroke: "#4E443D",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5384615,69.9622765 L36.5384615,54.753086 C36.5384615,39.6334388 48.7399321,30.4183811 63.7912088,30.4183811 C78.8424855,30.4183811 91.043956,39.6334388 91.043956,54.753086 L91.043956,69.9622765 M63.7912088,30.4183811 C72.1530292,30.4183811 78.9316239,23.6089945 78.9316239,15.2091905 C78.9316239,6.80938655 72.1530292,7.10542736e-15 63.7912088,7.10542736e-15 C55.4293884,7.10542736e-15 48.6507937,6.80938655 48.6507937,15.2091905 C48.6507937,23.6089945 55.4293884,30.4183811 63.7912088,30.4183811 Z M51.6788767,69.9622765 L51.6788767,32.6734826 M75.9035409,69.9622765 L75.9035409,32.6734826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1404151,84.6326062 L15.1404151,69.4234156 M39.3650794,84.6326062 L39.3650794,69.4234156 M-3.55271368e-14,84.6326062 L-3.55271368e-14,69.4234156 C-3.55271368e-14,54.3037685 12.2014706,45.0887108 27.2527473,45.0887108 C42.304024,45.0887108 54.5054945,54.3037685 54.5054945,69.4234156 L54.5054945,84.6326062 L54.5054945,84.6326062 M27.2527473,45.0887108 C35.6145676,45.0887108 42.3931624,38.2793242 42.3931624,29.8795202 C42.3931624,21.4797162 35.6145676,14.6703297 27.2527473,14.6703297 C18.8909269,14.6703297 12.1123321,21.4797162 12.1123321,29.8795202 C12.1123321,38.2793242 18.8909269,45.0887108 27.2527473,45.0887108 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(57 51)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 20,
    stroke: "#4E443D",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4E443D",
    strokeLinecap: "square",
    strokeWidth: 6,
    transform: "translate(20.98 20.095)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.274,
    x2: 16.735,
    y1: 8.48,
    y2: 8.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.23,
    x2: 8.23,
    y1: 16.461
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtSessionAdd);
export default __webpack_public_path__ + "static/media/pt-session-add.3c0af34982ec7393bc917f67f09dd1e6.svg";
export { ForwardRef as ReactComponent };